/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface Apiv3backofficeinventoryservicesDataAttributes
 */
export interface Apiv3backofficeinventoryservicesDataAttributes {
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryservicesDataAttributes
     */
    availabilityStatus?: Apiv3backofficeinventoryservicesDataAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryservicesDataAttributes
     */
    category?: Apiv3backofficeinventoryservicesDataAttributesCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryservicesDataAttributes
     */
    chargeType: Apiv3backofficeinventoryservicesDataAttributesChargeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryservicesDataAttributes
     */
    description?: string;
    /**
     * Custom object ordering position
     * @type {number}
     * @memberof Apiv3backofficeinventoryservicesDataAttributes
     */
    index?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Apiv3backofficeinventoryservicesDataAttributes
     */
    maxDuration?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Apiv3backofficeinventoryservicesDataAttributes
     */
    minDuration?: number;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryservicesDataAttributes
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryservicesDataAttributes
     */
    serviceType: Apiv3backofficeinventoryservicesDataAttributesServiceTypeEnum;
    /**
     * 
     * @type {Blob}
     * @memberof Apiv3backofficeinventoryservicesDataAttributes
     */
    thumbnail?: Blob | null;
}

/**
    * @export
    * @enum {string}
    */
export enum Apiv3backofficeinventoryservicesDataAttributesAvailabilityStatusEnum {
    Disabled = 'disabled',
    Private = 'private',
    Public = 'public'
}
/**
    * @export
    * @enum {string}
    */
export enum Apiv3backofficeinventoryservicesDataAttributesCategoryEnum {
    Buffet = 'buffet',
    Cocktail = 'cocktail',
    CoffeeBreak = 'coffee-break',
    Menu = 'menu',
    Others = 'others',
    Audio = 'audio',
    Illumination = 'illumination',
    Video = 'video'
}
/**
    * @export
    * @enum {string}
    */
export enum Apiv3backofficeinventoryservicesDataAttributesChargeTypeEnum {
    Day = 'day',
    Hour = 'hour',
    Person = 'person',
    Unit = 'unit'
}
/**
    * @export
    * @enum {string}
    */
export enum Apiv3backofficeinventoryservicesDataAttributesServiceTypeEnum {
    Audiovisual = 'audiovisual',
    FoodBeverage = 'food-beverage',
    Other = 'other'
}

